import React, { useState } from "react";
import styled from "styled-components";

import find from "lodash/find";

import Pagination from "@mui/material/Pagination";
import Box from "@mui/material/Box";

import useEstates from "../hooks/useEstates";
import Loader from "../shared/Loader";
import EstateItem from "./EstateItem";
import EstateDetail from "./EstateDetail";
import Modal from "../shared/Modal";
import useEstatesFilterStore, {
  INITAL_PAGE_SIZE,
} from "../stores/useEstatesFilterStore";
import FormValuesProvider, {
  useFormValuesContext,
} from "../context/FormValuesContext";
import SelectDuplicatedUnitsForm from "./SelectDuplicatedUnitsForm";

const CustomModalContext = ({
  children,
  open,
  handleClose,
  resetValues,
  ...props
}) => {
  const { setValues } = useFormValuesContext();
  const closeModalAndResetValues = () => {
    !!handleClose && handleClose();
    !!resetValues && setValues({});
  };

  return (
    <Modal open={open} handleClose={closeModalAndResetValues} {...props}>
      {children}
    </Modal>
  );
};

const EstateList = ({}) => {
  const [selectedEstate, setSelectedEstate] = useState();
  const [showEstateDetailModal, setShowEstateDetail] = useState(false);
  const [showSelectUnitsModal, setShowSelectUnitsModal] = useState(false);

  const page = useEstatesFilterStore((state) => state.page);
  const setPage = useEstatesFilterStore((state) => state.setPage);
  const { data, isFetching } = useEstates();
  const { estates = [], totalCount = 0, isGlobalSearch } = data;

  const totalPage = isGlobalSearch
    ? 0
    : Math.round(totalCount / INITAL_PAGE_SIZE);

  const showEstateDetail = (estateId) => {
    setSelectedEstate(find(estates, (e) => e.id === estateId));
    setShowEstateDetail(true);
  };

  const handleShowSelectUnitsModal = () => {
    setShowSelectUnitsModal(true);
    setShowEstateDetail(false);
  };

  const handleCloseSelectUnitsModal = () => {
    setShowSelectUnitsModal(false);
    setShowEstateDetail(true);
  };

  const closeEstateDetailModal = () => {
    setSelectedEstate(null);
    setShowEstateDetail(false);
  };

  const handleChangePage = (_, value) => setPage(value);

  return (
    <>
      <StyleWrapper className="estate__list d-flex flex-column">
        {isFetching ? (
          <Loader />
        ) : (
          <>
            {estates.map((estate) => (
              <EstateItem
                key={estate.id}
                estate={estate}
                showDetail={showEstateDetail}
              />
            ))}
            <Box display="flex" justifyContent="end">
              <Pagination
                count={totalPage}
                page={page}
                onChange={handleChangePage}
                shape="rounded"
              />
            </Box>
          </>
        )}
      </StyleWrapper>

      <FormValuesProvider>
        <CustomModalContext
          open={showEstateDetailModal}
          handleClose={closeEstateDetailModal}
          resetValues
        >
          <EstateDetail
            estate={selectedEstate}
            openSelectUnitsModal={handleShowSelectUnitsModal}
          />
        </CustomModalContext>
        <CustomModalContext
          open={showSelectUnitsModal}
          handleClose={handleCloseSelectUnitsModal}
        >
          <SelectDuplicatedUnitsForm />
        </CustomModalContext>
      </FormValuesProvider>
    </>
  );
};

const StyleWrapper = styled.div`
  margin-top: 10px;
  gap: 15px;
  overflow: hidden;
`;

export default EstateList;
